"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation deleteCorpCollection($collectionId: Int!) {
        deleteCorpCollection(input: { corpCollectionId: $collectionId }) {
            corpCollection {
                label
                id: corpCollectionId
            }
        }
    }
`;exports.deleteCorpCollection=e;
//# sourceMappingURL=queries.js.map
